import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { Dashboard } from './components/Dashboard'
import { StockAnalysis } from './components/StockAnalysis'
import { Opportunities } from './components/Opportunities'
import { Watchlist } from './components/Watchlist'
import { Reports } from './components/Reports'
import { Layout } from './components/Layout'
import { ReportsDetail } from './components/ReportsDetail'
import { Login } from './components/Login'

function App() {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Login />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="analyze" element={<StockAnalysis />} />
        <Route path="opportunities" element={<Opportunities />} />
        <Route path="watchlist" element={<Watchlist />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/:reportId" element={<ReportsDetail />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App

